import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

/** Build mat-table column ids from Prime-style col config (skip hidden). */
export function buildDisplayedColumns(cols: { field: string; hidden?: boolean }[]): string[] {
  return cols.filter((c) => !c.hidden).map((c) => c.field);
}

/** Width style object for mat-header/mat-cell ngStyle. */
export function getDstColStyle(col: { width?: string }): Record<string, string> {
  const width = col.width || '100px';
  return { width, minWidth: width, maxWidth: width };
}

/** Attach MatSort to a MatTableDataSource after view init or data refresh. */
export function connectMatTableSort<T>(dataSource: MatTableDataSource<T>, sort?: MatSort): void {
  if (sort) {
    dataSource.sort = sort;
  }
}

/** Recalculate CDK sticky column offsets after data load, resize, or column width change. */
export function refreshDstMatStickyColumns(
  table?: { updateStickyColumnStyles(): void },
): void {
  queueMicrotask(() => table?.updateStickyColumnStyles());
}